import { render, staticRenderFns } from "./advExpert.vue?vue&type=template&id=5a9662bc"
import script from "./advExpert.vue?vue&type=script&lang=js"
export * from "./advExpert.vue?vue&type=script&lang=js"
import style0 from "./advExpert.vue?vue&type=style&index=0&id=5a9662bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports